// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
import { Link, Redirect } from 'react-router-dom';
// COMPONENTS
import LoginForm from 'components/forms/LoginForm';
import PageContainer from 'components/common/PageContainer';
import Card from 'components/common/Card';
import message from 'antd/lib/message';
import AccountHelpers from 'lib/helpers/AccountHelpers';
import ApolloClient from 'ApolloClient';
import constants from 'lib/constants';
import logActivity from 'ApolloClient/Mutations/logActivity';
import { graphql } from 'react-apollo';

// CONSTANTS & DESTRUCTURING
// ========================================
const LINK_STYLE = { textAlign: 'center', marginTop: 20, color: '#fff' };

const Logo = styled.img`
  height: 61px;
  margin: auto;
  margin-bottom: 20px;
`;

const FormContainer = styled.div`
  width: 400px;
  text-align: center;
  max-width: 100%;
  margin: auto;
  padding-top: 20px;
`;

// STYLED-COMPONENTS
// ========================================

// EXPORTED COMPONENT
// ========================================
class Login extends React.PureComponent {
  state = {
    loading: false,
    errors: [], // holds errors from server, antd's FormItem handles displaying client validation errors of inputs
  };

  onSucessFullyValidated = async ({ username, password }) => {
    this.setState({ loading: true });

    let res;
    try {
      res = await AccountHelpers.handleLogin({ email: username, password });
    } catch (err) {
      return this.setState({
        loading: false,
        errors: [err.message.replace('GraphQL', '')],
      });
    }
    message.success('Welcome!');
    console.log(res);
    await this.props.logActivity({
      variables: {
        params: {
          userId: res,
          eventType: 'loginSuccess',
          date: new Date(),
          userAgent: window.navigator.userAgent,
        },
      },
    });
    await ApolloClient.resetStore();
    this.props.history.push('/dashboards');
  };

  onSuccessfulLogin = ({ access_token, refresh_token }) => {
    this.setState({ loading: false });
    message.success('Welcome back!');
    setTimeout(() => window.location.reload(), 800);
  };

  render() {
    if (this.props.currentUser) {
      return <Redirect to="/dashboards" />;
    }
    return (
      <PageContainer>
        <FormContainer>
          <div>
            <Logo src={constants.images.logoBlack} alt="cclariti-logo" />
            <LoginForm
              loading={this.state.loading}
              errors={this.state.errors}
              onSucessFullyValidated={this.onSucessFullyValidated}
            />
            <Link to="/forgot-password">Forgot your password?</Link>
            <br />
            <Link to="/contact">Need an account? Send us a message!</Link>
          </div>
        </FormContainer>
      </PageContainer>
    );
  }
}

// EXPORT
// ========================================
export default graphql(logActivity, { name: 'logActivity' })(Login);



// WEBPACK FOOTER //
// ./src/routes/auth-login/index.js